import { render, staticRenderFns } from "./QuoteNew.vue?vue&type=template&id=54c6396d&"
import script from "./QuoteNew.vue?vue&type=script&lang=js&"
export * from "./QuoteNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports